import React, { ReactElement, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import { isEmpty } from 'lodash';
import BasicModal from '../../modules/modals/BasicModal';
import HCaptcha from '../auth/Hcaptcha';
import { DashlineSeparator, HCaptchaContainer } from '../common/CommonStyle';
import Button from '../../atoms/buttons/Button';
import { getBackgroundTheme, getBorders } from '../../style';
import { Headline, NextButtonWrapper, buttonStyle, emailLabelStyle } from '../../screens/LoginStyle';
import { RootState } from '../../store';
import useMediaBreakpoints from '../../hooks/useMediaBreakpoints';
import { requestPhoneOtpAction, resetEmailOTPAction } from '../../actions/authActions';
import { isQAautomation, isQAautomationEmail } from '../../utils/helpers';

const WrapperStyle = styled('div')({
  display: 'block',
});

const BotDetectionModal = (props: any): ReactElement => {
  const { email, type, showBotModal, handleClose, handleClick, phoneNumber } = props;
  const [botCaptcha, setBotCaptcha] = useState<string>('');
  const { cf_country, isJoinCaptchaEnabled, isLoginCaptchaEnabled } = useSelector(
    (state: RootState) => state.attributes
  );
  const settings = useSelector((state: RootState) => state.settings);

  const dispatch = useDispatch();
  const { isMobile } = useMediaBreakpoints();

  const handleContinueClick = async () => {
    if (type === 'phone') {
      //call reset phone otp api
      await dispatch(requestPhoneOtpAction(phoneNumber, botCaptcha, true));
    } else {
      await dispatch(resetEmailOTPAction(email, type === 'verify_email_wall' ? 'change_email' : type, botCaptcha));
    }

    handleClick();
    handleClose();
    setBotCaptcha('');
  };

  const isBotCaptchaEnabled = (): boolean => {
    switch (type) {
      case 'join':
        return isJoinCaptchaEnabled;
      case 'login':
      case 'phone':
        return isLoginCaptchaEnabled;
      case 'change_email':
      case 'privateChangeEmail':
      case 'verify_email_wall':
        return settings?.is_member_hcaptcha_enabled;
      default:
        return false;
    }
  };

  return (
    <>
      <BasicModal
        isOpen={showBotModal}
        hideClose={true}
        customStyle={{
          content: {
            borderRadius: '20px',
            padding: '30px 20px',
            maxWidth: isMobile ? 312 : 355,
            backgroundColor: getBackgroundTheme().fsModal,
            border: getBorders().DEFAULT,
            zIndex: 100002,
          },
          overlay: {
            zIndex: 100002,
          },
        }}
        onClose={handleContinueClick}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
      >
        <WrapperStyle>
          <Headline
            style={{
              paddingTop: 30,
            }}
          >
            Are you a robot?{' '}
          </Headline>
          <DashlineSeparator />
          <p style={{ ...emailLabelStyle, margin: '0 0' }}>
            We’ve spotted some unusual activity on your account. Please complete the check below before we move forward.
          </p>
          <DashlineSeparator />
          {isBotCaptchaEnabled() && (
            <HCaptchaContainer>
              <HCaptcha storeCaptchaResponse={setBotCaptcha} cfCountry={cf_country} />
            </HCaptchaContainer>
          )}
          <NextButtonWrapper>
            <Button
              disabled={
                isBotCaptchaEnabled() && isEmpty(botCaptcha) && !(isQAautomation() || isQAautomationEmail(email))
              }
              customStyle={buttonStyle}
              buttonType="primaryRed"
              type="button"
              name="commit"
              onClick={handleContinueClick}
            >
              Continue
            </Button>
          </NextButtonWrapper>
        </WrapperStyle>
      </BasicModal>
    </>
  );
};

export default BotDetectionModal;
